import axios from 'axios'

const RequestService = {
  async get (params = {}) {
    return axios.get('wo/purchase-order/requests', { params })
  },

  async histories (params = {}) {
    return axios.get('wo/reports/purchase-order/request-histories', { params })
  },

  async show (id) {
    return axios.get(`wo/purchase-order/requests/${id}`)
  },

  async post (params = {}) {
    return axios.post('wo/purchase-order/requests', params)
  },

  async put (params = { id: '' }) {
    return axios.put(`wo/purchase-order/requests/${params.id}`, params)
  },

  async delete (data = { id: '' }) {
    return axios.delete(`wo/purchase-order/requests/${data.id}`, { data })
  }
}

export default RequestService
